import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.345 11.466a.833.833 0 0 1 .855-.188l2.246.786a.833.833 0 0 1 .164 1.495l-1.672 1.037a.833.833 0 0 1-1.234-.458l-.574-1.823a.833.833 0 0 1 .215-.85",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.74 5.845c.402.224.547.731.324 1.134l-.896 1.612h.656a.917.917 0 0 1 .755 1.436L11.87 12.51a.833.833 0 0 1-1.372-.946l.9-1.306h-.504a.917.917 0 0 1-.802-1.362l1.515-2.727a.833.833 0 0 1 1.133-.324",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.209 3.333c-.575 0-1.042.467-1.042 1.042v11.25c0 .575.467 1.042 1.042 1.042h1.458a.833.833 0 0 1 0 1.666H5.21a2.708 2.708 0 0 1-2.708-2.708V4.375a2.708 2.708 0 0 1 2.708-2.708h9.583a2.708 2.708 0 0 1 2.709 2.708v11.25a2.708 2.708 0 0 1-2.709 2.708h-4.791a.833.833 0 1 1 0-1.666h4.791c.576 0 1.042-.467 1.042-1.042V4.375c0-.575-.466-1.042-1.042-1.042z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.667 8.333c.46 0 .834.373.834.834v1.666a.833.833 0 0 1-1.667 0V9.167c0-.46.373-.834.833-.834",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }